<template>
  <div class="btn-group btn-group-toggle btn-group-colors event-tag">
    <el-tooltip
      v-for="color in colors"
      :key="color.value"
      effect="dark"
      :content="color.name"
      placement="top"
    >
      <label
        class="btn"
        :class="[color.value, { 'active focused': model === color.value }]"
        @click="model = color.value"
      />
    </el-tooltip>
  </div>
</template>

<script>
import { Tooltip } from "element-ui";

const DEFAULT_COLORS = [
  // From eventColors
  { value: "bg-info",   name: "Unidade" },
  { value: "bg-orange", name: "Corporativo" },
  { value: "bg-red",    name: "Apresentação" },
  { value: "bg-green",  name: "Aberto" },
  // From eventColors2
  { value: "bg-purple",  name: "Ciclo de vendas" },
  { value: "bg-pink",    name: "Apresentação" },
  { value: "bg-success", name: "Orientação" },
  { value: "bg-dark",    name: "Geral" },
]

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },
  props: {
    value: {
      type: String,
      default: () => ('bg-info'),
    },
    colors: Array,
  },
  computed: {
    colorOptions() {
      return this.colors || []
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
